import { ref, computed } from 'vue'
import axios from 'axios'
import { Loading } from 'element-plus/es/components/loading/src/service'

const status = ref<string | null>(null)
let interval: ReturnType<typeof setInterval> | null = null
const isConnected = computed(() => status.value === 'connected')

export default function useWhatsapp(){
    return{
        status,
        isConnected,
        getStatus,
        startPolling,
        stopPolling,
        Loading
    }
}

async function getStatus() {
    try {
        const response = await axios.get('/api/whatsapp/status')
        status.value = response.data.status
    } catch (error) {
        status.value = 'error'
        throw error
    }
}

async function startPolling() {

    if (interval) return

    try {
        await getStatus()
    } catch {

    }

    interval = setInterval(async () => {
    try {
        await getStatus()
    } catch (error) {
        console.error(error)
    }
    }, 5000)
}

function stopPolling(){

    if(interval){
        clearInterval(interval)
        interval = null
    }
}